import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";

import Header from "./components/header/header.component";
import OrdenesDePagoContaner from "./components/ordenes-container/ordenes-pago-container.component";

import "./App.css";
import ProveedorProvider from "./context/proveedor.context";

function App() {
    return (
        <ConfigProvider locale={esES}>
            <div className='App'>
                <div className='container'>
                    <Header />
                    <ProveedorProvider>
                        <OrdenesDePagoContaner />
                    </ProveedorProvider>
                </div>
            </div>
        </ConfigProvider>
    );
}

export default App;
